import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { reportingRouteNames, DashboardRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'
import { hasAllReportsSaaSProduct } from '@/util/reporting';
import store from '@/store'

const ReportingAdwordsIndex = () =>
  import(
    /* webpackChunkName: "adwords-reporting" */ '@/pmd/pages/reporting/adwords/ReportingAdwordsIndex.vue'
  ).then(m => m.default)
const ReportingFacebookIndex = () =>
  import(
    /* webpackChunkName: "fb-reporting" */ '@/pmd/pages/reporting/facebook/ReportingFacebookIndex.vue'
  ).then(m => m.default)
const AttributionDashboard = () =>
  import(
    /* webpackChunkName: "attribution-reporting-v2" */ '@/pmd/pages/reporting/attribution/AttributionDashboard.vue'
  ).then(m => m.default)
const AppointmentsReportPage = () =>
  import(
    /* webpackChunkName: "appointments-reports" */ '@/pmd/pages/reporting/appointment/AppointmentReportingDashboard.vue'
  ).then(m => m.default)
const AuditReportPage = () =>
    import(
      /* webpackChunkName: "audit-report" */ '@/pmd/pages/reporting/prospecting/AuditReport.vue'
  ).then(m => m.default)
const CallReportingDashboard = () =>
  import(
    /* webpackChunkName: "numberpool-dashboard" */ '@/pmd/pages/reporting/calls/CallReportingDashboard.vue'
  ).then(m => m.default)
const AgentReporting = () =>
  import(
    /* webpackChunkName: "agent-reporting" */ '@/pmd/pages/AgentReporting.vue'
  ).then(m => m.default)
const ReportingCustomContainer = () =>
  import(
    /* webpackChunkName: "custom-reports" */ '@/pmd/pages/reporting/reports/CustomReportsContainer.vue'
  ).then(m => m.default)

export const reportingRoute: RouteConfig[] = [
  {
    path: 'reporting',
    name: reportingRouteNames.default,
    component: EmptyRouterParent,
    beforeEnter: (to, from, next) => {
      const location = store.state.locations.currentLocation

      if (location && !hasAllReportsSaaSProduct(location)) {
        return next({
          name: DashboardRouteNames.default,
          params: to.params,
          query: to.query,
          replace: true,
        })
      }

      return requireAuthAndLocation(to, from, next);
    },
    children: [
      {
        path: 'reports',
        name: reportingRouteNames.customReport,
        component: ReportingCustomContainer,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'create',
            name: reportingRouteNames.customReportCreate,
            component: ReportingCustomContainer,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
              hideSideBar: true
            }
          },
          {
            path: 'view/:report_id',
            name: reportingRouteNames.customReportView,
            component: ReportingCustomContainer,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
              hideSideBar: true
            }
          },
          {
            path: 'schedule/:report_id',
            name: reportingRouteNames.customReportSchedule,
            component: ReportingCustomContainer,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
              hideSideBar: true
            }
          }
        ]
      },
      {
        path: 'google-ads',
        name: reportingRouteNames.google,
        component: ReportingAdwordsIndex,
        meta: {
          translations: [Modules.AdReporting],
        },
        children: [],
      },
      {
        path: 'facebook-ads',
        name: reportingRouteNames.facebook,
        component: ReportingFacebookIndex,
        children: [],
        meta: {
          translations: [Modules.AdReporting],
        }
      },
      {
        path: 'attribution',
        name: reportingRouteNames.attribution,
        component: AttributionDashboard,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'call',
        name: reportingRouteNames.callStats,
        component: CallReportingDashboard,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'agent',
        name: reportingRouteNames.agent,
        component: AgentReporting,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.AgentReporting] },
      },
      {
        path: 'appointment',
        name: reportingRouteNames.appointments,
        component: AppointmentsReportPage,
        beforeEnter: requireAuthAndLocation,
        meta: {hideTopBar: false}
      },
      {
        path: 'local-marketing-audit',
        name: reportingRouteNames.auditReport,
        component: AuditReportPage,
        beforeEnter: requireAuthAndLocation,
        meta: { hideTopBar: false }
      },
      {
        path: 'google',
        redirect: { name: reportingRouteNames.google },
      },
      {
        path: 'facebook',
        redirect: { name: reportingRouteNames.facebook },
      },
      {
        path: 'attribution-v2',
        redirect: { name: reportingRouteNames.attribution },
      },
      {
        path: 'attribution/attribution-v2',
        redirect: { name: reportingRouteNames.attribution },
      },
      {
        path: 'call_stats',
        redirect: { name: reportingRouteNames.callStats },
      },
      {
        path: 'agent_reporting',
        redirect: { name: reportingRouteNames.agent },
      },
      {
        path: 'appointments-reports',
        redirect: { name: reportingRouteNames.appointments },
      }
    ]
  }
]
